module.exports = __webpack_public_path__ + "assets/pillow.26c1947b.svg";